export enum AppConstants {
  Platform = "Web",
  BidRound = 0,
  Token = "00000000-0000-0000-0000-000000000000",
  AppNum = 12,
}

export enum ConstraintType {
  AtMost = 1,
  Exactly,
  AtLeast,
}

export enum NoOkMiddleType {
  NoMiddle = 1,
  OkMiddle,
}

export enum CommuteFrBaOvType {
  Front = 1,
  Back,
  Overall,
}

export enum CommureGreaterLesser {
  Greater = 1,
  Lesser,
}

export enum DaysofWeek {
  Mondays,
  Tuesdays,
  Wednesdays,
  Thursdays,
  Fridays,
  Saturdays,
  Sundays,
}

export enum AMPMDefault {
  FA = 1200,
  Pilot = 800,
}

export enum BulkCitiesStatusType {
  Normal = 0,
  Yes,
  No,
  Disabled,
}

export enum BidLineType {
  NormalTrip = 0,
  NoTrip,
  VA,
  VAP,
  VO,
  VD,
  VOFSplit,
  VOBSplit,
  VDDrop,
  VOFSplitDrop,
  VOBSplitDrop,
  FV,
}

export enum ColumnDefenitionType {
  Normal = 1,
  VacForAll,
  VacForPilot,
  Ignored,
  VacForFA,
  VacForSwap,
  VacNormal
}

export enum WorkBlockDays {
  workBlock1 = 1,
  workBlock2,
  workBlock3,
  workBlock4,
}

export enum ColDefDataFormats {
  //Comments are example values
  Number = 1, //34
  FloatSingleDec, //1.5
  FloatDoubleDec, //9.98
  FloatDoubleDecWithColor, //Red for Negative, Green for Positive
  FloatTripleDec, //0.009
  TimeHHmm, //22:45
  TimeHHmmss, //20:55:15
  FourDigit, // 0654
  TimeTotHours, // 64:59
  Percentage //20.28%
}

export enum BidFileTypes {
  NormalLine = 1,
  Trip,
  Vacation,
  VacationDropOFF,
  Eom,
  EomDropOFF,
  VacationEOM,
  VacationEomDropOFF,
}

//Type of FA reserve type for the 2nd Round.
export enum FAReserveType
{
    SeniorAMReserve = 1,
    SeniorPMReserve,
    JuniorAMReserve,
    JuniorPMReserve,
    JuniorLateReserve
}

export enum PDOFilterType {
  AtAfter = 1,
  AtBefore
}